import styled from 'styled-components'

export const AdminDashboardContainer = styled.div`
  padding: 0;
  background: #ffffffff;
  min-height: 100vh;
`

export const DashboardHeader = styled.div`
  margin-bottom: 32px;
`

export const DarkBlueHeader = styled.div`
  background: transparent;
  padding: 24px;
  color: black;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

export const HeaderTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: black;
  margin: 0 0 12px 0;
`

export const HeaderSubtitle = styled.p`
  font-size: 16px;
  color: #666;
  margin: 0;
`

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const TimeIndicator = styled.span`
  font-size: 14px;
  color: #666;
`

export const RefreshButton = styled.button`
  color: #fff;
  border-color: #3249D7;
  background: #3249D7;
  // text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  // box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #1e38a8;
    border-color: #1e38a8;
  }

  &:active {
    background: #1a2d8a;
    border-color: #1a2d8a;
  }
`

export const DashboardContent = styled.div`
  padding: 24px;
  position: relative;
`

export const DashboardTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 8px 0;
`

export const DashboardSubtitle = styled.p`
  font-size: 16px;
  color: #8c8c8c;
  margin: 0;
`

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 32px;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const MetricCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(50, 73, 215, 0.3);
    transform: translateY(-2px);
  }
  
  ${props => props.clicked && `
    box-shadow: 0 4px 12px rgba(50, 73, 215, 0.3);
    transform: translateY(-2px);
  `}
`

export const MetricCardWrapper = styled.div`
  position: relative;
  z-index: ${props => props.showDropdown ? 10 : 1};
`

export const MetricCardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

export const MetricIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  
  svg {
    width: 32px;
    height: 32px;
    color: ${props => props.color || '#8c8c8c'};
  }
`

export const MetricTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0;
`

export const MetricValuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const MetricValueItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const MetricValueLabel = styled.span`
  font-size: 14px;
  color: #8c8c8c;
  font-weight: 500;
`

export const MetricValueNumber = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: #262626;
`

// Dropdown styles
export const DropdownContainer = styled.div`
  margin-top: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 300px;
`

export const DropdownHeader = styled.div`
  padding: 16px 24px;
  background: #001529;
  color: white;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const DropdownList = styled.div`
  padding: 16px 0;
  flex: 1;
`

export const DropdownItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f8f9fa;
  }
  
  &:last-child {
    border-bottom: none;
  }
`

export const StatusIndicator = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => 
    props.status === 'online' || props.status === 'Active' ? '#52c41a' : 
    props.status === 'offline' || props.status === 'Inactive' ? '#ff4d4f' : '#faad14'
  };
  box-shadow: 0 0 0 3px ${props => 
    props.status === 'online' || props.status === 'Active' ? '#52c41a20' : 
    props.status === 'offline' || props.status === 'Inactive' ? '#ff4d4f20' : '#faad1420'
  };
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`

// Credentials Modal styles
export const CredentialsModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;

  .modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }

  .modal-header {
    background: #001529;
    color: white;
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }

    .close-btn {
      background: none;
      border: none;
      color: white;
      font-size: 24px;
      cursor: pointer;
      padding: 0;
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }

  .modal-body {
    padding: 24px;
  }

  .credential-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      display: block;
      font-weight: 600;
      color: #262626;
      margin-bottom: 8px;
      font-size: 14px;
    }

    .credential-value {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f5f5f5;
      padding: 12px 16px;
      border-radius: 6px;
      border: 1px solid #d9d9d9;
      font-family: 'Courier New', monospace;
      font-size: 14px;
      color: #262626;

      .copy-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 16px;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: rgba(24, 144, 255, 0.1);
        }
      }
    }
  }
`

// Tabs styles
export const TabsContainer = styled.div`
  margin-top: 24px;
  background: white;
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
`

export const TabsList = styled.div`
  display: flex;
  border-bottom: 1px solid #f0f0f0;
`

export const TabItem = styled.button`
  background: none;
  border: none;
  padding: 16px 24px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.active ? '#001529' : '#8c8c8c'};
  cursor: pointer;
  border-bottom: 2px solid ${props => props.active ? '#001529' : 'transparent'};
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    color: #001529;
    background-color: #f8f9fa;
  }
  
  &:focus {
    outline: none;
  }
`

export const TabContent = styled.div`
  padding: 24px;
`

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 16px;
  color: #8c8c8c;
`

export const GreetingContainer = styled.div`
  margin-bottom: 24px;
  padding: 16px 0;
`

export const GreetingText = styled.h2`
  font-size: 24px;
  font-weight: 500;
  color: #262626;
  margin: 0;
`
